<template>
  <div class="loading-wrapper" v-if="show">
    <van-loading type="spinner" />
  </div>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
@Component({
})
export default class LoadingWrapper extends Vue {
  @Prop({default:false})
  show
}
</script>
<style lang="less" scoped>
.loading-wrapper {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, .6);
  z-index: 99999;
}
</style>